/**
 * widgets/registry.dns.tsx — DNS widget-first UI.
 *
 * Zóny: live load z providera, BIND export, snapshoty, šablony.
 * Stránka: pages/modules/dns.tsx → ModuleWorkspace + catalog.
 */
import { Globe, KeyRound, Server, ShieldCheck, Wand2 } from 'lucide-react';
import type { WidgetSpec } from './types';
import {
  DnsDomainsWidget,
  DnsProvidersWidget,
  DnsServerWidget,
  DnsTemplatesWidget,
  DnsZonesWidget,
} from '../pages/modules/dns';

export const DNS_WIDGETS: WidgetSpec[] = [
  {
    id: 'dns.providers',
    title: 'DNS provideři',
    module: 'dns',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: KeyRound,
    component: DnsProvidersWidget,
  },
  {
    id: 'dns.zones',
    title: 'Zóny a záznamy',
    module: 'dns',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Globe,
    component: DnsZonesWidget,
  },
  {
    id: 'dns.templates',
    title: 'Šablony zón',
    module: 'dns',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Wand2,
    component: DnsTemplatesWidget,
  },
  {
    id: 'dns.server',
    title: 'DNS server',
    module: 'dns',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Server,
    component: DnsServerWidget,
  },
  {
    id: 'dns.domains',
    title: 'Domény tenantů',
    module: 'dns',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: ShieldCheck,
    component: DnsDomainsWidget,
  },
];
